<template>
  <div>
    <h1>OPS</h1>
    <p>Qualcosa � andato storto</p>
    <router-link to="/" tag="a" class="nav-item">
      <a >Home</a>
    </router-link>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  components: {

  },
  mounted () {

  },
  computed: {

  },
  methods: {

  },

  created () {

  }

}
</script>
